"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _typeIcon = _interopRequireDefault(require("./type-icon.style"));

var _icon = _interopRequireDefault(require("../../icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const TypeIcon = ({
  variant,
  transparent
}) => {
  return /*#__PURE__*/_react.default.createElement(_typeIcon.default, {
    variant: variant,
    transparent: transparent
  }, /*#__PURE__*/_react.default.createElement(_icon.default, {
    type: variant,
    bgTheme: "none"
  }));
};

TypeIcon.defaultProps = {
  variant: "info",
  transparent: false
};
TypeIcon.propTypes = {
  variant: _propTypes.default.oneOf(["default", "error", "help", "info", "maintenance", "new", "success", "warning"]),
  transparent: _propTypes.default.bool
};
var _default = TypeIcon;
exports.default = _default;